import { Modal } from "src/atoms/Modal";
import { BrandInfo } from "src/molecules/BrandInfo";
import { AlgoliaSearchBrand } from "src/types/Algolia";

interface AlgoliaBrandInfoProps {
  open: boolean;
  onClose: () => void;
  brand: AlgoliaSearchBrand;
}

const AlgoliaBrandInfo = ({
  open,
  onClose,
  brand,
}: AlgoliaBrandInfoProps): JSX.Element | null => {
  return (
    <Modal isOpen={open} onClose={onClose} overFlow="hidden">
      <BrandInfo brandInfo={brand} onClose={onClose} pageType="pdp" />
    </Modal>
  );
};

export default AlgoliaBrandInfo;
